export const invoicesExcelColumnDefs = [
	{
		header: "Status",
		accessor: "invoiceStatusId",
		type: "string",
	},
	{
		header: "Art",
		accessor: "invoiceTypeId",
		type: "string",
	},
	{
		header: "Kunde",
		accessor: "companyDisplayName",
		type: "string",
	},
	{
		header: "Rechnungsnummer",
		accessor: "invoiceNumber",
		type: "string",
	},
	{
		header: "Rechnungsbetrag (brutto)",
		accessor: "subtotalCents",
		type: "currency",
	},
	{
		header: "Leistungszeitraum",
		accessor: "deliveryPeriodFormatted",
		type: "string",
	},
	{
		header: "Versendet am",
		accessor: "transactionDate",
		type: "date",
	},
	{
		header: "Fällig am",
		accessor: "paymentDueAt",
		type: "date",
	},
	{
		header: "Gebucht am",
		accessor: "sentAt",
		type: "date",
	},
	{
		header: "Bemerkungen",
		accessor: "comment",
		type: "string",
	},
];